import React, { useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Badge from "react-bootstrap/Badge";

import AuthService from "./services/auth.service";

import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardUser from "./components/BoardUser";
import BoardModerator from "./components/BoardModerator";
import BoardAdmin from "./components/BoardAdmin";
import Ofertas from "./components/Ofertas";
import Cobros from "./components/Cobros";
import ControlFotos from "./components/ControlFotos";

import { useNavigate } from "react-router-dom";

import EventBus from "./common/EventBus";

//import logo from "./assets/logo.png";
import logo from "./assets/logoAux.png";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import PruebasCamara from "./components/PruebasCamara";
import Carrito from "./components/Carrito";
import Pedidos from "./components/Pedidos";
import ImprimirEtiquetas from "./components/ImprimirEtiquetas";
import PageNotFound from "./components/404";
import Permisos from "./components/Permisos";
import TablaPermisos from "./components/TablaPermisos";
import Usuarios from "./components/Usuarios";
import Cheques from "./components/Cheques";
import EmpleadosAdmin from "./components/EmpleadosAdmin";
import HistoricoCajas from "./components/HistoricoCajas";
import ClientesInactivos from "./components/ClientesInactivos";
import ArticulosTienda from "./components/Tienda/ArticulosTienda";
import ProductoDetalle from "./components/Tienda/ProductoDetalle";
import MisPrecios from "./components/Tienda/MisPrecios";
import ProtectedRoute from "./components/ProtectedRoute";
import { Cart, Person, BoxArrowRight, List } from "react-bootstrap-icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useCart } from "react-use-cart";

import { Modal, Button, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

const App = () => {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
  const [expanded, setExpanded] = useState(false);

  const { totalItems, emptyCart, cartTotal } = useCart();

  // Modal Card//
  const [tituloModalCard, setTituloModalCard] = useState("Art");
  const [fullscreenCard, setFullscreenCard] = useState(true);
  const [showCard, setShowCard] = useState(false);
  const [dataArt, setDataArt] = useState();
  // Fin Modal Card//

  const navigate = useNavigate();

  const userState = useSelector((state) => state.user.value);
  const dispatch = useDispatch();

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
      setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, []);

  const logOut = () => {
    AuthService.logout();
    navigate("/");
    setShowModeratorBoard(false);
    setShowAdminBoard(false);
    setCurrentUser(undefined);
    setExpanded(false);
  };

  const closeMenu = () => setExpanded(false);

  const limpiarCarrito = () => {
    setShowCard(true);
  };

  const cerrarModalCard = () => {
    setShowCard(false);
  };
  const cerrarModalCardVaciandoCarrito = () => {
    emptyCart();
    setShowCard(false);
  };

  //TODO ver si se puede cambiar las leyendas de la tabla de artículos
  //TODO Ver como agregar coordenadas del maps
  //TODO Traer solo los pedidos sin procesar, despúes hacer los incompletos
  //TODO ver si en el carrito deslogea la sesión

  return (
    <Container fluid>
      <Navbar
        collapseOnSelect
        expand="lg"
        className="custom-navbar sticky-top"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Navbar.Brand as={Link} to="/" className="navbar-brand-custom">
          <img
            src={logo}
            width="32"
            height="32"
            className="brand-logo"
            alt="José Karam y Otros S.H"
          />
          <span className="brand-text">Karam</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" className="navbar-toggle-custom">
          <List size={24} />
        </Navbar.Toggle>
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto nav-main-links">
            {showModeratorBoard && (
              <Nav.Link as={Link} onClick={closeMenu} to="/empleado" className="nav-link-custom">
                Empleado
              </Nav.Link>
            )}
            {showAdminBoard && (
              <Nav.Link as={Link} onClick={closeMenu} to="/admin" className="nav-link-custom">
                Administrador
              </Nav.Link>
            )}
            {currentUser && (
              <Nav.Link as={Link} onClick={closeMenu} to="/tienda" className="nav-link-custom">
                Tienda
              </Nav.Link>
            )}
            {currentUser && (
              <Nav.Link as={Link} onClick={closeMenu} to="/pedidos" className="nav-link-custom">
                Mis Pedidos
              </Nav.Link>
            )}
            {currentUser && (
              <Nav.Link as={Link} onClick={closeMenu} to="/etiquetas" className="nav-link-custom">
                Etiquetas
              </Nav.Link>
            )}
          </Nav>

          <Nav className="nav-user-actions ms-auto">
            {currentUser ? (
              <>
                {currentUser.cuenta_corriente != null && (
                  <Badge
                    pill
                    className={`saldo-badge ${
                      parseFloat(userState.cuenta_corriente.saldo) >= 0
                        ? "saldo-positivo"
                        : "saldo-negativo"
                    }`}
                  >
                    {parseFloat(userState.cuenta_corriente.saldo).toFixed(2)}
                  </Badge>
                )}

                <Nav.Link as={Link} onClick={closeMenu} to="/mis-precios" className="nav-link-custom">
                  Mis precios
                </Nav.Link>

                <NavDropdown
                  title={
                    <span className="cart-toggle">
                      <span className="cart-icon-wrap">
                        <Cart size={20} />
                        <Badge pill className="cart-count">
                          {totalItems.toFixed(0)}
                        </Badge>
                      </span>
                      <span className="cart-total">
                        ${cartTotal.toFixed(2)}
                      </span>
                    </span>
                  }
                  id="cart-dropdown"
                  className="cart-dropdown"
                  align="end"
                >
                  <NavDropdown.Item as={Link} to="/cart" onClick={closeMenu}>
                    Ver Carrito
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={() => {
                      limpiarCarrito();
                      closeMenu();
                    }}
                  >
                    Limpiar Carrito
                  </NavDropdown.Item>
                </NavDropdown>

                <NavDropdown
                  title={
                    <span className="user-toggle">
                      <Person size={20} />
                      <span className="user-name">{currentUser.username}</span>
                    </span>
                  }
                  id="user-dropdown"
                  className="user-dropdown"
                  align="end"
                >
                  <NavDropdown.Item as={Link} to="/profile" onClick={closeMenu}>
                    Mi perfil
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={logOut}>
                    <BoxArrowRight size={16} className="me-2" />
                    Salir
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <>
                <Nav.Link as={Link} onClick={closeMenu} to="/login" className="nav-link-custom">
                  Ingresar
                </Nav.Link>
                <Nav.Link as={Link} onClick={closeMenu} to="/register">
                  <Button variant="dark" size="sm" className="btn-register">
                    Registrarse
                  </Button>
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className="container mt-3">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/articulos" element={<ProtectedRoute><BoardUser /></ProtectedRoute>} />
          <Route path="/tienda" element={<ProtectedRoute><ArticulosTienda /></ProtectedRoute>} />
          <Route path="/tienda/:id" element={<ProtectedRoute><ProductoDetalle /></ProtectedRoute>} />
          <Route path="/mis-precios" element={<ProtectedRoute><MisPrecios /></ProtectedRoute>} />
          <Route path="/ofertas" element={<ProtectedRoute><Ofertas /></ProtectedRoute>} />
          <Route path="/empleado" element={<ProtectedRoute><BoardModerator /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><BoardAdmin /></ProtectedRoute>} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword/:token" element={<ResetPassword />} />
          <Route path="/pruebas" element={<PruebasCamara />} />
          <Route path="/cart" element={<ProtectedRoute><Carrito /></ProtectedRoute>} />
          <Route path="/pedidos" element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
          <Route path="/etiquetas" element={<ProtectedRoute><ImprimirEtiquetas /></ProtectedRoute>} />
          <Route path="/admin/permisos" element={<ProtectedRoute><Permisos /></ProtectedRoute>} />
          <Route
            path="/admin/permisos/editar/:id"
            element={<ProtectedRoute><TablaPermisos /></ProtectedRoute>}
          />
          <Route path="/admin/usuarios" element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
          <Route path="/admin/cobros" element={<ProtectedRoute><Cobros /></ProtectedRoute>} />
          <Route path="/admin/fotosarticulos" element={<ProtectedRoute><ControlFotos /></ProtectedRoute>} />
          <Route path="/admin/cheques" element={<ProtectedRoute><Cheques /></ProtectedRoute>} />
          <Route path="/admin/historicocajas" element={<ProtectedRoute><HistoricoCajas /></ProtectedRoute>} />
          <Route path="/admin/empleados" element={<ProtectedRoute><EmpleadosAdmin /></ProtectedRoute>} />
          <Route path="/admin/clientesinactivos" element={<ProtectedRoute><ClientesInactivos /></ProtectedRoute>} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Modal
        show={showCard}
        fullscreen={fullscreenCard}
        onHide={() => cerrarModalCard()}
      >
        <Modal.Header>
          <Modal.Title>Alerta</Modal.Title>
          <Button variant="outline-danger" onClick={() => cerrarModalCard()}>
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex justify-content-center">
            <Col>Desea Vaciar el carrito?</Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            onClick={() => cerrarModalCardVaciandoCarrito()}
          >
            Vaciar
          </Button>
          <Button variant="success" onClick={() => cerrarModalCard()}>
            Salir
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default App;
